import styled from 'styled-components';
import { IThemeProvider } from '../../../styles/theme';

export const InformationTextCont = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.deka} 0;
    height: ${theme.layout.spacing.peta};
 `}
`;

export const Container = styled.div`
  width: 432px;
`;
